import React, { useState, useEffect } from "react";
import { Spin } from "antd";
// import "./PieChart.css"
import "../../GlobalCss/SPF/PieChart.css"
import { Progress } from 'antd';

const PieChart = ({ displayCycle, PerData }) => {
    const [completePercentage, setCompletePercentage] = useState(0);
    const [incomplete, setIncomplete] = useState(100)
    const [spinner, setSpinner] = useState(true);
    const [name, setName] = useState('Regular Payroll')
    useEffect(() => {
        if (PerData !== undefined) {
            const objectLength = Object.keys(PerData).length;
            if (displayCycle === 1) {
                setName('Regular Payroll')
                if (objectLength > 0) {
                    setSpinner(true)
                    const tempdata = parseFloat(PerData["New Hire/ Re-Hires"]) + parseFloat(PerData["Health Insurance"])
                        + parseFloat(PerData["Garnishments"]) + parseFloat(PerData["Payroll Timecards"]) + parseFloat(PerData["Payroll Masterfile"])
                        + parseFloat(PerData["Payroll Adjustment"]) + parseFloat(PerData["Payroll Audit/ Review"]) + parseFloat(PerData["Payroll Export/ .CSV"]);
                    const sampleData = parseFloat(tempdata / 8);
                    const roundedNumber = sampleData.toFixed(0);
                    const incmplt = 100 - roundedNumber;
                    setIncomplete(incmplt)
                    const cmplt = 100 - incmplt
                    setCompletePercentage(cmplt)
                    setSpinner(false)
                }
            }
            else if (displayCycle === 2) {
                setName('Off Cycle Payroll')
                if (objectLength > 0) {
                    setSpinner(true)
                    const tempdata = parseFloat(PerData["Off-Cycle Payroll"])
                    const sampleData = parseFloat(tempdata / 1);
                    const roundedNumber = sampleData.toFixed(0);
                    // setCompletePercentage(roundedNumber)
                    const incmplt = 100 - roundedNumber;
                    setIncomplete(incmplt)
                    const cmplt = 100 - incmplt
                    setCompletePercentage(cmplt)
                    setSpinner(false)
                }
            }
            else if (displayCycle === 3) {
                setName('Expenses Management')
                if (objectLength > 0) {
                    setSpinner(true)
                    let tempdata = parseFloat(PerData["Contigent Expenses"]) + parseFloat(PerData["Corporate Expenses"]);
                    const sampleData = parseFloat(tempdata / 2);
                    const roundedNumber = sampleData.toFixed(0);
                    // setCompletePercentage(roundedNumber)
                    const incmplt = 100 - roundedNumber;
                    setIncomplete(incmplt)
                    const cmplt = 100 - incmplt
                    setCompletePercentage(cmplt)
                    setSpinner(false)
                }
            }
        }
    }, [PerData, displayCycle])
    const myStyle = {
        background: `conic-gradient(  transparent ${completePercentage}%, rgba(240, 240, 240, 1) ${completePercentage+0.2}%),
        radial-gradient(circle, rgba(59, 82, 223, 1) 66.5%, rgba(133, 182, 255, 0.2) 74%)`,
    };
    // radial-gradient(circle, rgba(0, 58, 140, 1) 65%, rgba(133, 182, 255, 0.2) 74%)
    const styleSecond = {
        background: `conic-gradient( rgba(240, 240, 240, 1) ${incomplete}%, transparent ${incomplete}%),
                     radial-gradient(circle, rgba(133, 182, 255, 0.2) 50%, rgba(0, 58, 140, 1)50%)`,
    };
    return (<>
        <div className="piechart-wholediv">
            <div className="piechart">
                {/* {spinner ? <div className="pie-spinner"><Spin size="large" /></div> : */}
                <div className="doughnut-class" >
                    <div className="outer"
                        style={incomplete === 100 ? styleSecond : myStyle}>
                        <div className="inner">
                            <div className="chart-data">
                                <div className="percent-class" style={{ marginBottom: 4 }}><span className="span-name">{name}</span></div>
                                <div className="percent-class" style={{fontWeight:600, color:"rgba(59, 82, 223, 1)"}}>{completePercentage}%</div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* } */}
            </div>
        </div>
    </>);
}
export default PieChart;
